// Servizio dominio SERVIZI (utility: navetta, auto, legna, gas, assicurazione…): vetrina pubblica randomizzata + gestione CRM.
import { api, unwrap } from './client';

const g = (path, params, config) => unwrap(api.get(path, { params, ...(config || {}) }));
const p = (path, body, config) => unwrap(api.post(path, body, config));
const u = (path, body, config) => unwrap(api.put(path, body, config));
const d = (path, config) => unwrap(api.delete(path, config));

export const rentalsService = {
  // ---- Vetrina pubblica (aggregata + randomizzata) ----
  publicList: (category) => g('/rentals/public', category && category !== 'tutte' ? { category } : {}),
  publicCategories: () => g('/rentals/public/categories'),
  publicGet: (idOrSlug) => g(`/rentals/public/${idOrSlug}`),
  quote: (body) => p('/rentals/public/quote', body),
  checkout: (body) => p('/rentals/public/checkout', body),
  // Checkout Stripe reale (Payment Element, anche ospite senza login)
  checkoutIntent: (body) => p('/rentals/public/checkout/intent', body),
  checkoutConfirm: (orderId) => p('/rentals/public/checkout/confirm', { order_id: orderId }),

  // ---- Area clienti ----
  customerOrders: () => g('/rentals/customer/orders'),

  // ---- Gestione (stakeholder + admin) ----
  list: (params) => g('/rentals', params),
  get: (sid) => g(`/rentals/${sid}`),
  create: (body) => p('/rentals', body),
  update: (sid, body) => u(`/rentals/${sid}`, body),
  setStatus: (sid, status) => p(`/rentals/${sid}/status`, { status }),
  remove: (sid) => d(`/rentals/${sid}`),
  categories: () => g('/rentals/categories'),
  checkin: (code) => p('/rentals/checkin', { code }),
  orders: () => g('/rentals/orders'),

  // ---- Admin ----
  adminOverview: () => g('/rentals/admin/overview'),
};

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
// QR reale del voucher (riusa il generatore biglietteria: codifica /biglietto/{code}).
export const rentalQrUrl = (code) => `${BACKEND}/api/experience/public/qr/${encodeURIComponent(code)}.png`;
export const rentalPublicUrl = (slug) => `${window.location.origin}/servizi/${slug}`;

// Etichette tipologie SERVIZI utility (allineate al backend services/rentals.py).
// NB: le categorie sono dinamiche (create liberamente dagli operatori); questa mappa
// è solo un fallback per gli slug suggeriti.
export const RENTAL_CATEGORY_LABELS = {
  'auto-noleggio': 'Auto a noleggio', navetta: 'Navetta / Transfer',
  'energia-rinnovabile': 'Energia rinnovabile', assicurazione: 'Assicurazione',
  'internet-satellitare': 'Internet satellitare', legna: 'Legna da ardere',
  gas: 'Bombola del gas', 'manutenzione-casa': 'Manutenzione / Casa', altro: 'Altro',
};

export const rentalCategoryLabel = (slug) => RENTAL_CATEGORY_LABELS[slug] || (slug || 'Servizio');
